<template>
  <v-navigation-drawer
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
      color="concrete"
      floating
      v-model="$store.state.drawer"
  >
    <v-list color="concrete" shaped>
      <v-subheader>Выберите папку с тикетами</v-subheader>
      <v-list-item-group color="primary">
        <v-list-item
            v-for="(item,index) in items"
            :key="'appBarItem_'+index"
            exact
            :to="{name: item.path}"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <template v-slot:append>
      <div class="pa-2">
        <v-btn v-if="isBoardEnabled" color="white" light block :to="{name: 'boards'}" exact class="mb-3">
          <v-icon left>mdi-table-headers-eye</v-icon> Канбан
        </v-btn>
        <v-btn color="white" light block :to="{name: 'account_report'}" exact class="mb-3">
          <v-icon left>mdi-file-table-outline</v-icon> Детализация
        </v-btn>
        <v-btn color="masala" dark block :to="{name: 'posts'}" exact class="mb-3">
          <v-icon left>mdi-help-circle-outline</v-icon> Справка
        </v-btn>
        <v-btn color="primary" block :to="{name: 'create'}" exact >
          <v-icon left>mdi-plus</v-icon> Новый запрос
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'Navigation',
  data: () => ({
    items: [
      {
        name: 'Все открытые',
        icon: 'mdi-clock-outline',
        badge: 1,
        path: 'actual'
      },
      {
        name: 'Мои открытые',
        icon: 'mdi-star-outline',
        badge: 0,
        path: 'personal'
      },
      {
        name: 'Архив запросов',
        icon: 'mdi-archive-outline',
        badge: 0,
        path: 'archive'
      },
      {
        name: 'Телеграм чаты',
        icon: 'mdi-chat-processing-outline',
        badge: 0,
        path: 'chats'
      }
    ],
    loading: false,
    isBoardEnabled: 0
  }),
  methods: {
    getBoardStatusEnabled() {
      this.loading = true;
      this.$http.get(`${this.$serverApiLink}kanban/status`).then(
          response => {
            this.isBoardEnabled = response.data.data;
            this.loading = false;
          }
      ).catch(
          error => {
            this.$store.commit('setSnack', {
              status: true,
              code: error.response.status,
              message: error.response.data.message,
              type: 'error'
            });
            window.console.log(error.response)
            this.loading = false;
          }
      );
    },
  },
  mounted() {
    this.getBoardStatusEnabled();
  }
}
</script>